export class Application {
	submitApp(parent)
	{
		let _this = this;
		
		$.ajax({
			type: "POST",
			url: '/ajax.php?mid=16',
			dataType: 'json',
			data: $(parent).serialize() + '&action=addObject',
			success: function(res)
			{
				if (res.success)
				{
					$('form').html('<h2>Спасибо! Ваша заявка отправлена.</h2><p>Ссылка на Вашу заявку: <a href="/sell/?object=' + res.id + '">http://vsop.versus-ltd.org/sell/?object=' + res.id + '</a></p>');
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	checkHiddenInvalids()
	{
		let invalids = $('form input:invalid, form select:invalid, form textarea:invalid');
		if (invalids.length)
		{
			let b = invalids.closest('.allpb-application__block');
			b.find('.allpb-application__block-toggler').addClass('active');
			b.find('.allpb-application__block-main').show();
		}
	}

	validateStep(parent)
	{
		let errors = 0;
		let b = $(parent).closest('.allpb-application__block-main');
		b.find('input, select, textarea').each(function(){
			if (!this.checkValidity()) {
				errors++;
				this.reportValidity();
				return false;
			}
		});

		return !errors;
	}

	restrictions()
	{
		$('input[name^=mlt_business_areas]').click(function()
		{
			if ($(this).prop('checked'))
			{
				console.log($('input[name^=mlt_business_areas]:checked').length);
				if ($('input[name^=mlt_business_areas]:checked').length > 5)
				{
					return false;
				}
			}
		});
	}
	
}